import api from './api';

// Service for contact-related API calls
const contactService = {
  /**
   * Submit contact form data to the API
   * @param {Object} formData - Contact form data (name, email, phone, message, etc.)
   * @returns {Promise} - API response
   */
  submitContactForm: async (formData) => {
    try {
      const response = await api.post('/contact', formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Subscribe to newsletter
   * @param {Object} data - Newsletter data (email, etc.)
   * @returns {Promise} - API response
   */
  subscribeToNewsletter: async (data) => {
    try {
      const response = await api.post('/newsletter/subscribe', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Submit a quick inquiry form
   * @param {Object} formData - Inquiry form data
   * @returns {Promise} - API response
   */
  submitQuickInquiry: async (formData) => {
    try {
      const response = await api.post('/inquiry', formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Submit course enrollment request
   * @param {Object} enrollmentData - Enrollment form data
   * @returns {Promise} - API response
   */
  submitEnrollment: async (enrollmentData) => {
    try {
      const response = await api.post('/enrollment', enrollmentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Get FAQ data
   * @returns {Promise} - API response with FAQ items
   */
  getFaqs: async () => {
    try {
      const response = await api.get('/faqs');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default contactService;
